import { h } from '@stencil/core';
import { rangeBasePath } from '@pes-ui/utils';
import { getCurrentReference } from '../utils/range-helpers';
export class RangeNodeHeader {
  constructor() {
    this.handleLinkClick = (event) => {
      if (!this.isPBS)
        return;
      event.preventDefault();
      this.previousNodeSelected.emit();
      this.nodeSelected.emit({
        nodeReference: getCurrentReference(Boolean(this.backUrl), rangeBasePath, this.backUrl, this.isPBS),
      });
    };
    this.backUrl = undefined;
    this.backUrlTitle = undefined;
    this.levelTitle = undefined;
    this.isPBS = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "range-node-header" }, this.backUrl && (h("qds-standalone-link", { size: "small", importance: "standard", href: this.isPBS ? '#' : this.backUrl, onClick: this.handleLinkClick, iconName: "chevron-left" }, this.backUrlTitle)), this.levelTitle && h("h4", { class: "range-node-header__prev-level-title" }, this.levelTitle)));
  }
  static get is() { return "pes-range-node-header"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-node-header.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-node-header.css"]
    };
  }
  static get properties() {
    return {
      "backUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "back-url",
        "reflect": false
      },
      "backUrlTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "back-url-title",
        "reflect": false
      },
      "levelTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "level-title",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "previousNodeSelected",
        "name": "previousNodeSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }, {
        "method": "nodeSelected",
        "name": "nodeSelected",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "RangeNode",
          "resolved": "{ id?: string; image?: ImageLink; name?: string; navigationState?: string; nodeReference?: string; url?: string; nodes?: Nodes[]; }",
          "references": {
            "RangeNode": {
              "location": "import",
              "path": "../types"
            }
          }
        }
      }];
  }
  static get elementRef() { return "el"; }
}
